import Template from "./template.jsx";

export default {
  index: true,
  element: <Template />,
  loader: async () => {
    return {};
  },
};
